import { csi } from '../../lib/utils/bolt';
import { flushExchangeEvents } from './analytics/analytics.utils';

export const harakiri = async () => {
  // closeExtension() tears the page down at once, aborting in-flight requests.
  // Bounded wait, never longer than a second — the panel must still close.
  await flushExchangeEvents(1000);

  csi.closeExtension();

  setTimeout(() => {
    process.kill(process.ppid, 'SIGKILL');
  }, 5000);
};
